module.exports = __webpack_public_path__ + "img/big.55b28937.jpg";